(() => {
  if (customElements.get('sf-home-portraitwall')) return;

  class SFPortraitWall extends HTMLElement {
    connectedCallback() {
      if (this.abort) return;
      this.abort = new AbortController();
      const options = { signal: this.abort.signal };
      this.querySelectorAll('[data-wall-play]').forEach(button => {
        button.hidden = false;
        button.addEventListener('click', () => this.start(button.closest('[data-wall-card]')), options);
      });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) this.video?.pause();
      }, options);
      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(entries => {
          if (!entries[0].isIntersecting) this.video?.pause();
        }, { threshold: 0 });
      }
    }

    async start(card) {
      const template = card.querySelector('[data-wall-template]');
      if (!template) return;
      this.stop();
      document.querySelectorAll('sf-home-portraitwall').forEach(wall => {
        if (wall !== this) wall.stop?.();
      });
      this.card = card;
      const media = card.querySelector('[data-wall-media]');
      const button = card.querySelector('[data-wall-play]');
      const status = card.querySelector('[data-wall-status]');
      const video = template.content.querySelector('video').cloneNode(true);
      this.video = video;
      card.classList.add('is-current');
      status.textContent = 'Video wird geladen …';
      status.hidden = false;
      button.hidden = true;
      media.append(video);
      this.observer?.observe(media);

      const ambient = this.querySelector('[data-wall-ambient]');
      const poster = card.querySelector('[data-wall-poster] img');
      if (ambient && poster) {
        const image = poster.cloneNode();
        image.alt = '';
        ambient.replaceChildren(image);
        ambient.hidden = false;
      }
      const error = () => {
        if (this.video !== video) return;
        const hadFocus = document.activeElement === video;
        this.stop();
        status.textContent = 'Das Video konnte nicht geladen werden. Bitte versuche es erneut.';
        status.hidden = false;
        if (hadFocus) button.focus({ preventScroll: true });
      };
      video.addEventListener('error', error);
      video.addEventListener('playing', () => { status.hidden = true; });
      video.addEventListener('play', () => {
        document.querySelectorAll('sf-home-portraitwall').forEach(wall => {
          if (wall !== this) wall.stop?.();
        });
      });
      video.focus({ preventScroll: true });
      try {
        await video.play();
        if (this.video === video) status.hidden = true;
      } catch {
        error();
      }
    }

    stop() {
      this.observer?.disconnect();
      if (this.video) {
        const video = this.video;
        this.video = null;
        video.pause();
        video.removeAttribute('src');
        video.querySelectorAll('source').forEach(source => source.removeAttribute('src'));
        video.load();
        video.remove();
      }
      if (this.card) {
        this.card.classList.remove('is-current');
        this.card.querySelector('[data-wall-play]').hidden = false;
        this.card.querySelector('[data-wall-status]').hidden = true;
        this.card = null;
      }
    }

    disconnectedCallback() {
      this.stop();
      this.abort?.abort();
      this.abort = null;
    }
  }

  customElements.define('sf-home-portraitwall', SFPortraitWall);
})();
